import { useNavigate } from "react-router";
import { FlexDivider } from "../widgets/utils"
import LocationTracker from "./location"
import { useContext, useState } from "react";
import { State, StateContext } from "../state";
import { Avatar, Badge, Button, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { AccountCircle, FavoriteBorder } from "@mui/icons-material";
import { SearchBar } from "./searchbar";
import { T } from "../i18n";
import { GoogleLogin } from "@react-oauth/google";

export const flags: any = {
  it: require('./images/it.png'),
  en: require('./images/en.png')
}

const menuStyle = {
  overflow: 'visible',
  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
  mt: 1.5,
  '& .MuiAvatar-root': {
    width: 32,
    height: 32,
    ml: -0.5,
    mr: 1,
  },
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    top: 0,
    right: 14,
    width: 10,
    height: 10,
    bgcolor: 'background.paper',
    transform: 'translateY(-50%) rotate(45deg)',
    zIndex: 0,
  }
}


export const Header = ({hideSearchBar}: any) => {

  const { chartList, preferiteList, selectedLang, setSelectedLang, account, setGoogleLoginToken } = useContext(StateContext) as State;
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [anchorElP, setAnchorElP] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const openP = Boolean(anchorElP);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const select = (lang:string) => {
    setSelectedLang(lang);
    handleClose();
  }

  return ( 
    <div className='header'>
      <div className="row container">
        <div className="logo-title" onClick={() => navigate('/')}>Outdoora</div>
        <FlexDivider />
        {!hideSearchBar &&
          <>
            <SearchBar />
            <FlexDivider/>
          </>
        }
        <div className="row gap-10-5 header-buttonsheet">
          <div className='btn-icon' onClick={() => navigate('saved')}>
            <Badge badgeContent={preferiteList.length} color="error">
              <FavoriteBorder/> 
            </Badge>
            <span className="hide-xs">Favourite</span>
          </div>
          {/* <div className='btn-icon' onClick={() => navigate('/checkout')}>
              <Badge badgeContent={chartList.length} color="primary">
                <ShoppingCartIcon/> 
              </Badge>
              <span className="hide-xs">Cart</span>
          </div> */}
          <div className='btn-icon' onClick={handleClick}>
            <IconButton
              size="small"
              aria-controls={open ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              sx={{padding: 0}}
            >
              <Avatar sx={{ color: "black", fontWeight: "bold", width: 21, height: 21, backgroundImage: `url('${flags[selectedLang]}')`, backgroundSize: 'cover', backgroundRepeat: "no-repeat", backgroundPosition: "center", border: "1px solid black" }}>&nbsp;</Avatar>
            </IconButton>
            <span className="hide-xs">Language</span>
          </div>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            slotProps={{
              paper: {
                elevation: 0,
                sx: menuStyle,
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <MenuItem onClick={() => select('it')}>
              <Avatar src={flags.it}/> Italian
            </MenuItem>
            <MenuItem onClick={() => select('en')}>
              <Avatar src={flags.en}/> English
            </MenuItem>
          </Menu>
          <div className='btn-icon' onClick={(event) => setAnchorElP(event.currentTarget)}>
            <AccountCircle style={{height: 30, width: 30}}/> 
            <span className="hide-xs">Profile</span>
          </div>
          <Menu
            anchorEl={anchorElP}
            open={openP}
            onClose={() => setAnchorElP(null)}
            onClick={() => setAnchorElP(null)}
            slotProps={{
              paper: {
                elevation: 0,
                sx: {...menuStyle, width: 300},
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <div className="pad-20 row" 
              // onClick={() => navigate('profile')}
            >
              <Avatar src=""/> {account ? (
                <div>
                  <Typography>{account.name}</Typography>
                  <Typography>{account.email}</Typography>
                </div>
              ) : T("anonymous")}
            </div>
            {account &&
            <div className="pad-20">
              <Button className="fullwidth" variant="contained" sx={{ borderRadius: '16px'}} onClick={() => navigate('account')}>
                {T('my_payments_title')}
              </Button>
            </div>
            }
            {!account &&
              <div className="pad-20">
                <GoogleLogin
                  onSuccess={credentialResponse => {
                    setGoogleLoginToken(credentialResponse.credential)
                  }}
                  onError={() => {
                    console.log('Login Failed');
                  }}
                />
              </div>
            }
          </Menu>

          <LocationTracker/>
          {/* <div className='btn-icon'><a href="/admin/" target="_blank" className='no-link'>Admin</a></div> */}
      </div>
      </div>
    </div>
  )
}